<template>

    <div class="v-application v-application--is-ltr theme--light">

        <v-card elevation="24">

            <v-card-title class="text-h6">
                {{ title || 'Update' }}
            </v-card-title>

            <v-card-text v-if="message">
                {{ message || 'Are you sure that you would like to perform this action?' }}
            </v-card-text>
            <div class="modal-create-data-section edit-date-input-section">
                <div class="modal-create-data-item">
                    <p>Start Time</p>
                    <input ref="keyStartTime" type="datetime-local" class="visitor-modal-title" v-model="keyStartTime"
                        :min="getMinimumDateForKeys()" />
                </div>
                <div class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Expiration Time</p>
                    <input ref="keyEndTime" type="datetime-local" class="visitor-modal-title" v-model="keyEndTime"
                        :min="getMinimumDateForKeys()" />
                </div>
                <div v-if="shouldShowPassPrinted" class="modal-create-data-section">
                    <input ref="passPrinted" type="checkbox" v-model="passPrinted"/>
                    <label style="margin-left: 8px;">Parking Pass Printed?</label>
                </div>
            </div>
            <v-card-text v-if="disclaimer" style="color: black; padding-top: 0px;">
                {{ disclaimer || 'By selecting Confirm, you are authorizing this action to be taken' }}
            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="confirm">
                    {{ confirmText || 'Confirm' }}
                </v-btn>
                <v-btn color="red" text @click="close">
                    {{ cancelText || 'Cancel' }}
                </v-btn>
            </v-card-actions>

        </v-card>

    </div>

</template>

<script>
import { PARKING_PASS } from '../../../js/constants';
import { featureEnabledForRole } from '../../../js/features';

export default {
    props: ["title", "message", "disclaimer", "cancelText", "confirmText", "onConfirm", "keyData", "userData"],
    data() {
        return {
            keyStartTime: this.formatDate(new Date(this.$props.keyData.time_active)),
            keyEndTime: this.formatDate(new Date(this.$props.keyData.expiration_time)),
            passPrinted: this.$props.keyData.pass_printed,
            currentStatus: this.$props.keyData.current_status,
            type: this.$props.keyData.key_type
        }

    },
    computed: {
        shouldShowPassPrinted() {
            return this.$config.showParkingPass && featureEnabledForRole(PARKING_PASS, this.$props.userData['custom:cts_role'])
        }
    },
    methods: {

        close() {
            this.$emit('close');
        },

        async confirm() {
            if (!this.onConfirm) {
                this.close();
                return;
            }
            const preservedValues = []
            let constructedPassPrinted = 0
            if(this.passPrinted) {
                constructedPassPrinted = 1
            }
            const constructedData = {
                'time_active': new Date(this.keyStartTime).toISOString(),
                'expiration_time': new Date(this.keyEndTime).toISOString(),
                'current_status': this.currentStatus,
                'key_type': this.type,
                'pass_printed': constructedPassPrinted.toString()
            }
            for (const key of Object.keys(constructedData)) {
                if (constructedData[key] == this.$props.keyData[key]) {
                    constructedData[key] = ""
                    preservedValues.push(key)
                }
            }
            if (preservedValues.length == Object.keys(constructedData).length) {
                this.close();
                return;
            }
            await this.onConfirm(constructedData);
            this.close();
        },
        getMinimumDateForKeys() {
            const date = new Date();
            const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            const formatted = offsetDate.toISOString().slice(0, 16);
            return formatted
        },
        formatDate(date) {
            const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            const formatted = offsetDate.toISOString().slice(0, 16);
            return formatted
        }

    }

};
</script>

<style scoped>
.vuetify-modal-wrapper {
    background: transparent;
}

.edit-date-input-section {
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 1em;
}
</style>